
import { Component, Vue, Prop } from 'vue-property-decorator';
import { default as axios, AxiosResponse } from 'axios';
import { viewportService } from '../../shared/services/ViewportService';

@Component({})
export default class EmployeeProfileImage extends Vue {
    @Prop() imageUrl: string;
    @Prop() eventListener: (callBackFunction: () => void) => void;
    private defaultImageUriCode: string = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAADACAAAAAB3tzPbAAACOUlEQVR4Ae3aCQrrIBRG4e5/Tz+CBAlIkIAECUjoSt48z/GZeAvnrMCvc6/38XzxAAAAYC4AAAAAAAAAAAAAAAAAAAAAAAAAAAAMCAAAAAAAAAAAAAAAAPsagz4V4rq/FmCLTj/k4vYqgCN5/TKfjlcAJKff5pJ5QPH6Y77YBiz6a4thQJ30D03VKmB3+qfcbhOwO+l+waP/+VsEBgDV6USumgNMOtVkDbDoZIstQNHpiimA1+m8JUBSQ8kO4HBqyB1mAElNJTMAr6a8FcCmxjYjgKjGohGAU2POBmBXc7sJwKrmVhOAqOaiCUBQc8EEQO0JwPMB4ADASwhAe3yR8VPiP3/M8XOaPzQd/lLyp56xSuvnUGK0yHC313idCw6umNov+bhm5aK7fdWAZQ/WbdoXnlg5Y+mvfe2SxVdWj20FAAAAAAAAAAAAwFQAAJSS0hwmfVMIc0qlmAfsOQWvP+RDyrtNQM1L0D8WllxNAWqOXifzMVcbgG3xaswv22jAFp3a6zFteYw8fQ9DM6Amr275VG8GlFmdm8uNgDzpgqZ8EyB7XZTPNwDKpAubysWAOuvi5nolYHW6PLdeBjiCbikc1wCK0025cgUg68Zyf0DUrcXegKibi30Bq25v7QnYNKCtH+BwGpA7ugFmDWnuBSgaVOkECBpU6AOoGlbtAlg1rLULIGhYoQvAaViuC0AD6wE4Xh1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA194CuqC6onikxXwAAAAASUVORK5CYII=';
    private loadedImageUriCode: string = null;
    private timeoutId: any = null;
    private get imageUriCode() {
        return this.loadedImageUriCode || this.defaultImageUriCode;
    }

    mounted() {
        if (viewportService.isInViewport(this.$el as HTMLElement)) {
            this.loadImage();
        } else {
            setTimeout(() => {
                if (this.eventListener) {
                    this.eventListener(() => this.loadImage());
                } else {
                    window.addEventListener('scroll', () => this.loadImage());
                }
            }, 100);
        }
    }

    private async loadImage() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(async () => {
            if (this.loadedImageUriCode || !viewportService.isInViewport(this.$el as HTMLElement) || !this.imageUrl) {
                return;
            }
            const result = await axios.get<string>(this.imageUrl, {
                responseType: 'arraybuffer'
            });

            const mimeType = result.headers['content-type'].toLowerCase();
            const imgBase64 = new Buffer(result.data, 'binary').toString('base64');
            this.loadedImageUriCode = `data:${mimeType};base64,${imgBase64}`;
            this.$emit('loaded');
        }, 300);
    }
}
